import { airportCodeToCityNameHe, cityNameHeFromCityLike } from "./airportCodeToCityHe";
import { lookupDestinationByIata, normalizeDestinationIata } from "./destinationTranslations";

const IATA_RE = /^[A-Za-z]{3}$/;
const HEBREW_RE = /[\u0590-\u05FF]/;

function looksLikeIata(value) {
  return IATA_RE.test(String(value ?? "").trim());
}

function trimText(value) {
  return String(value ?? "").trim();
}

function isReadableDestinationLabel(value) {
  const text = trimText(value);
  if (!text) return false;
  if (looksLikeIata(text)) return false;
  return true;
}

function firstIataCode(values) {
  for (const value of values) {
    const fromField = normalizeDestinationIata(value);
    if (fromField) return fromField;
    if (looksLikeIata(value)) return String(value).trim().toUpperCase();
  }
  return null;
}

/**
 * Public package-card destination: Hebrew city name + IATA for the country flag.
 * Never prefers a raw airport code when a real name can be resolved.
 *
 * @param {{
 *   destinationCode?: unknown,
 *   hotelCity?: unknown,
 *   destinationHint?: unknown,
 * }} [input]
 * @returns {{ label: string, destinationCode: string|null }}
 */
export function resolvePublicPackageCardDestination(input = {}) {
  const destinationCode = input.destinationCode;
  const hotelCity = input.hotelCity;
  const destinationHint = input.destinationHint;

  const code = firstIataCode([destinationCode, hotelCity, destinationHint]);
  const lookupHe = code ? trimText(lookupDestinationByIata(code)?.labelHe) : "";
  const catalogHe = code ? trimText(airportCodeToCityNameHe(code)) : "";
  const fromHotel = trimText(cityNameHeFromCityLike(hotelCity));
  const fromHint = trimText(cityNameHeFromCityLike(destinationHint));

  const candidates = [lookupHe, catalogHe, fromHotel, fromHint, destinationHint, hotelCity]
    .map(trimText)
    .filter(Boolean);

  const hebrew = candidates.find((value) => HEBREW_RE.test(value) && !looksLikeIata(value));
  const readable = candidates.find(isReadableDestinationLabel);
  const label = hebrew || readable || "";

  return {
    label: label || code || "",
    destinationCode: code,
  };
}
